import { CombinationKey, HAND_COMBINATIONS } from '@lbs/shared-rp-types'
import {
  BoxCardHolderDTO,
  CardHolderViewModel,
  CombinationDisplay,
  DealerCardHolderDTO,
} from './CardHolder.types'

function resolveCombination(
  handName: string,
  isBox: boolean,
  isDetailView: boolean,
  extraHandName?: string
): CombinationDisplay {
  if (!(handName in HAND_COMBINATIONS) || !isDetailView) {
    return { type: 'none' }
  }

  if (handName === 'HIGH_CARD') {
    return isBox ? { type: 'none' } : { type: 'noGame' }
  }

  const result: CombinationDisplay = {
    type: 'combination',
    handName: handName as CombinationKey,
  }

  if (
    extraHandName &&
    extraHandName in HAND_COMBINATIONS &&
    result.type === 'combination'
  ) {
    result.extraHandName = extraHandName as CombinationKey
  }

  return result
}

export function mapBoxToCardHolderVM(
  dto: BoxCardHolderDTO
): CardHolderViewModel {
  const {
    cards,
    handName,
    extraHandName,
    isBuySixCardAvailable,
    isSwitchAvailable,
    hasSelectedCardsForSwitch,
    darkenedCards,
    btnDecision,
    onToggleCardsForSwitch,
    onSetSixCardDecision,
    isDetailView,
    isMyTurn,
    isInteractive,
    animateCombination,
    onRevealComplete,
    showCombination,
  } = dto

  const isSwitchMode = hasSelectedCardsForSwitch && isSwitchAvailable
  const isExtraActionEnabled =
    isInteractive && (isBuySixCardAvailable || isSwitchAvailable)
  // Keep extra-action slot stable for 5-card detail view.
  // Show only for active box decisions flow (ready/revealed). Hide on settled/finished.
  // Also hide when hand is already expanded to 6 cards.
  const showExtraActionSlot = isDetailView && isMyTurn && cards.length <= 5

  return {
    viewMode: isDetailView ? 'detail' : 'compact',
    cards,
    combination: resolveCombination(
      handName,
      true,
      isDetailView,
      extraHandName
    ),
    animateCombination,
    showSwitchNotice: isDetailView && isSwitchAvailable,
    enableHoverFlip: !isSwitchAvailable,
    extraAction:
      showExtraActionSlot
        ? {
            variant: isSwitchMode ? 'switchCards' : 'buySixCard',
            isActive: btnDecision === 'sixCard' && !isSwitchMode,
            isEnabled: isExtraActionEnabled,
            onAction: isSwitchMode ? () => {} : onSetSixCardDecision,
          }
        : null,
    cardInteraction: isDetailView
      ? {
          isClickable: isSwitchAvailable,
          darkenedCards: new Set(darkenedCards),
          onClick: isSwitchAvailable ? onToggleCardsForSwitch : () => {},
        }
      : null,
    cardSlots: cards.length <= 5 ? 5 : 6,
    isDetailView,
    hasTopOffset: isDetailView,
    onRevealComplete,
    showCombination: showCombination ?? true,
  }
}

export function mapDealerToCardHolderVM(
  dto: DealerCardHolderDTO
): CardHolderViewModel {
  return {
    viewMode: dto.isDetailView ? 'detail' : 'compact',
    cards: dto.cards,
    combination: resolveCombination(dto.handName, false, dto.isDetailView),
    animateCombination: false,
    showSwitchNotice: false,
    enableHoverFlip: true,
    extraAction: null,
    cardInteraction: null,
    cardSlots: dto.cards.length <= 5 ? 5 : 6,
    isDetailView: dto.isDetailView,
    hasTopOffset: false,
    showCombination: true,
  }
}
